<template>
    <div style="padding: 5px 15px 0px 15px;">
      <div>
        <input class="inputs" name="" type="text" placeholder="输入标签名" v-model="newmodel.content" />
        <span class="xo-table-btn" @click="addNewTag(newmodel)">确认添加</span>
        <div class="rdiv pt20" style="padding-bottom: 20px;">
          <img v-if="newmodel.style && newmodel.style!==''" :src="newmodel.style"  class="upload_img" style="left: 100px; width: 90px; height: 90px;"/>
          <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'style'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
        </div>
      </div>
      <div v-if="lists && lists.length > 0">
        <p class="tagswitcher">
          没有合适的标签？您可以<a @click="switchTags" style="color: #ff3363; cursor: pointer;">换一批</a>
        </p>
      </div>
      <div v-if="lists && lists.length > 0" style="min-height: 78px;">
        <div v-for="item in lists" :key="item.id" :class="[item.checked ? 'tag-checked': 'tag-item']" @click='checkedOne(item, $event)'>
          {{item.content}}
        </div>
      </div>
      <div>
        已打的标签:(左一标签作为主标签，空间不够时仅显示左一标签)
        <div>
          <div v-for="item in selections" :key="item.id" style="display: inline-block; vertical-align: middle;">
            <span class="tag-item-solid">{{item.content}}</span>
            <img v-if="item.style" :src="item.style" alt="" width="24" height="24" style="vertical-align: middle;">
            <span style="vertical-align: middle; cursor: pointer;" @click="delTag(item)">x</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import utils from '@/utils'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
    export default {
      components: { UploadOSS },
      mounted () {
        this.getSTS()
        this.OSSUploadSuccess()
      },
      watch: {
        'params': {
          handler (newVal, oldVal) { // 改变不同的部门/人员 从父级组件获取到该部门/人员对应的已达标签
            /*
            * 因为父级组件传递数据后监听了变化，然后需要调用this.changeData，这时建立了this.params.lists和this.selections的对应关系（浅复制）
            * 因此每次this.selections变化时，会影响到this.params
            * 故需要 let lists = utisl.copyArray(newVal.lists)来存储一个深复制的数组
            * */
            let l = utils.copyArray(newVal.lists)
            this.filter.type = newVal.type // 切换不同的类型
            this.currentTagObject = newVal.currentTagObject
            this.changeData(l) // 初始化选中值, 改变Selections
            this.resetTags() // 重置标签的选中状态
          },
          deep: true
        }
      },
      data () {
        return {
          newmodel: {}, // 新增的标签Model
          currentTagObject: {}, // 当前打标签的对象（部门/人员/课程...）
          filter: {
            pageNo: 1,
            pageSize: 8,
            type: '' // '01': '人员标签', '02': '部门标签'
          },
          switchNo: 1,
          lists: [], // 可供选择的标签列表
          cnt: 0, // 可供选择的标签列表的数量
          selections: [], // 用户选择的标签列表
          uploadOSSConf: { showMode: '1', style: 'img_upload5', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
        }
      },
      props: ['params'],
      methods: {
        editTags () {
          this.$api.post(this.$global.tagApiPath, '/tagInfo/edit', this.newmodel, r => {
          })
        },
        switchTags () {
          this.switchNo++
          var maxPage = Math.ceil(this.cnt / this.filter.pageSize)
          if (this.switchNo > maxPage) { this.switchNo = 1 }
          this.filter.pageNo = this.switchNo
          this.resetTags()
        },
        resetTags () {
          this.getTags(this.filter).then((r) => {
            if (r) {
              utils.setVal(r, 'checked', false)
              this.lists = r
            } else {
              this.lists = []
            }
            this.setSelectedTag(this.lists, this.selections) // 更新checkbox选中状态
          })
        },
        addNewTag (item) {
          if (!$.isEmptyObject(item)) {
            let idIndex =  utils.findElem(this.selections, 'id', item.id)
            if (idIndex == -1) {
              this.selections.push(item)
            }
            this.saveTag(item)
          } else {
            this.$toasted.show('请不要添加空标签')
          }
        },
        checkedOne (item, e) {
          item.checked = !item.checked
          let idIndex =  utils.findElem(this.selections, 'id', item.id)
          if (idIndex >= 0) {
            this.selections.splice(idIndex, 1)
          } else {
            this.selections.push(item)
          }
          // this.$emit('userTagsUpdated', $.extend(true, [], this.selections))
          this.onlySaveTagRelations()
        },
        delTag (item) {
          let idIndex =  utils.findElem(this.selections, 'id', item.id)
          this.selections.splice(idIndex, 1)
          this.resetTags()
          this.onlySaveTagRelations()
        },
        getTags (filter) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.tagApiPath, '/tagInfo/findList', filter, r => {
              resolve(r.data)
              that.cnt = r.cntData
            })
          })
        },
        saveTag (item) { // 后台将新加标签保存到标签库、然后保存标签关系
          var that = this
          item.type = this.filter.type
          this.$api.post(this.$global.tagApiPath, '/tagInfo/edit', item, r => {
            var tagId;
            if (r.data) {
              tagId = r.data.id
            }
            for (let i = 0; i < this.selections.length; i++) {
              if (!this.selections[i].id) { // 此条数据是新加的标签
                this.selections[i].id = tagId
              }
            }
            this.onlySaveTagRelations().then((res) => {
              this.filter.pageNo = this.switchNo
              this.resetTags()
            })
          })
        },
        onlySaveTagRelations () {
          var ids;
          var a;
          var that = this;
          if (this.selections && this.selections.length > 0) {
            ids = utils.arr2str(utils.grabVal(this.selections, 'id'))
            a = [{itemId: this.currentTagObject.id, tagId: ids, type: this.filter.type}]
          } else {
            a = [{itemId: this.currentTagObject.id, type: this.filter.type}]
          }
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.tagApiPath, '/teamTag/edit', {teamTagList: a}, (r) => { // 正常
              resolve(r)
            })
          })
        },
        changeData (arr) { // 变更当前的已择标签列表
          if (arr && arr.length) {
            this.selections = arr
          } else {
            this.selections = []
          }
        },
        setSelectedTag (targetarr, sourcearr) { // 给当前标签列表中设置选中的Tag的Selected
          for (let i = 0; i < sourcearr.length; i++) {
            let obj = sourcearr[i]
            let idx = utils.findElem(targetarr, 'id', obj.id)
            if (idx > -1) {
              targetarr[idx].checked = true
            }
          }
        },
        getSTS () {
          this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
            let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
            this.uploadOSSConf.STS = STS
          })
        },
        OSSUploadSuccess (r) {
          if (r && r != '') {
            this.$set(this.newmodel, r.dom_id, r.res.requestUrls[0])
          }
        }
      }
    }
</script>

<style scoped>
  .xo-table-btn {
    padding: 5px;
    margin-right: 3px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  .tag-item {
    min-width: 40px;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    margin-right: 5px;
    margin-bottom: 5px;
    color: #666;
    border: 1px solid #666;
    position:  relative;
    display: inline-block;
    float: left;
    cursor: pointer;
    z-index: 6;
  }
  .tag-checked {
    min-width: 40px;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    margin-right: 5px;
    margin-bottom: 5px;
    color: #ff3633;
    border: 1px solid #ff3633;
    position:  relative;
    display: inline-block;
    float: left;
    cursor: pointer;
    z-index: 6;
  }
  .tag-item-solid {
    min-width: 40px;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    margin-right: 5px;
    margin-bottom: 5px;
    color: white;
    background-color: rgba(255,54,51,1);
    border: 1px solid rgba(255,54,51,1);
    position:  relative;
    display: inline-block;
    float: left;
    cursor: pointer;
    z-index: 6;
  }
  .inputs {
    width: 180px;
    height: 26px;
    line-height: 26px;
    border: 1px solid #bcbcbc;
    background: #fff;
    vertical-align: middle;
  }
  .tagswitcher {
    height: 35px;
    line-height: 35px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/tagPicker/index.vue